import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/app/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/app/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/app/.nuxt/sentry-client-config.mjs";
import siteConfig_JRId4KOeUL from "/app/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/siteConfig.js";
import inferSeoMetaPlugin_JSh5nGhzCz from "/app/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/inferSeoMetaPlugin.js";
import titles_eoILE7jqvj from "/app/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/titles.js";
import plugin_client_5j40ijIZYu from "/app/node_modules/@nuxtjs/plausible/dist/runtime/plugin.client.js";
import plugin_Jozdw60ZsE from "/app/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import plugin_client_OVoKJro5pc from "/app/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_KeztEmR1eT from "/app/node_modules/nuxt-graphql-request/dist/runtime/plugin.js";
import ws_client_wjC0pXbLHd from "/app/node_modules/@lenne.tech/nuxt-base/dist/runtime/plugins/ws.client.js";
import graphql_meta_MpvuLbixem from "/app/node_modules/@lenne.tech/nuxt-base/dist/runtime/plugins/graphql-meta.js";
import cookies_Ls3Gn6G3gr from "/app/node_modules/@lenne.tech/nuxt-base/dist/runtime/plugins/cookies.js";
import carousel_client_2SlSRKIyKz from "/app/src/plugins/carousel.client.ts";
import error_handler_eQzajpVw3N from "/app/src/plugins/error-handler.ts";
import form_plugin_osd0LcgVc1 from "/app/src/plugins/form.plugin.ts";
import pwa_plugin_5TbVodmYD6 from "/app/src/plugins/pwa.plugin.ts";
import plugin_auto_pageviews_client_x3Y8XIaaPY from "/app/node_modules/@nuxtjs/plausible/dist/runtime/plugin-auto-pageviews.client.js";
import defaults_M8ptihKv0z from "/app/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/defaults.js";
export default [
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  siteConfig_JRId4KOeUL,
  inferSeoMetaPlugin_JSh5nGhzCz,
  titles_eoILE7jqvj,
  plugin_client_5j40ijIZYu,
  plugin_Jozdw60ZsE,
  plugin_client_OVoKJro5pc,
  plugin_KeztEmR1eT,
  ws_client_wjC0pXbLHd,
  graphql_meta_MpvuLbixem,
  cookies_Ls3Gn6G3gr,
  carousel_client_2SlSRKIyKz,
  error_handler_eQzajpVw3N,
  form_plugin_osd0LcgVc1,
  pwa_plugin_5TbVodmYD6,
  plugin_auto_pageviews_client_x3Y8XIaaPY,
  defaults_M8ptihKv0z
]